// Which API this build talks to.
//
// Hardcoded per environment: uncomment one, leave the others commented.
//
// WARNING — two things have to agree here:
//   1. this line, and
//   2. the committed `build/` output, which bakes the URL in at build time.
// Netlify serves the committed build, so changing this file alone does NOT
// change what production calls. Rebuild and commit `build/` with it.
//
// `develop` carries the dev URL, so merging develop into main brings it to
// production unless this is checked. That is what #675 did.
// export const switchEndpoint = "https://api.dev.switchrecycling.com/api/v1";
// export const switchEndpoint = "https://api.staging.switchrecycling.com/api/v1";
export const switchEndpoint = "https://api.switchrecycling.com/api/v1";
